module.exports = __webpack_public_path__ + "img/18 Animation 2-squashed.6c46f935.jpg";